import type {Identified} from 'typings/portaro.be.types';

export interface Permission {
    action: string;
    subject?: {id: any};
}

export class PermissionsBuilder {

    private permissions: Permission[] = [];

    public addPermission(action: string, subject?: Identified<number|string>): this {
        const permission: Permission = {action};
        if (subject) {
            permission.subject = {id: subject.id};
        }

        this.permissions
            .push(permission);

        return this;
    }

    /**
     * Returns permission sorted by name
     *
     * @returns {Permission[]}
     */
    public build(): Permission[] {
        return this.permissions.sort((a, b) => a.action.localeCompare(b.action));
    }
}
